import Vue from "vue";
import { Store, Module, ActionContext } from "vuex";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import ListMutations from "./list-mutations";
import Team from "../entities/team";
import Cookies from "js-cookie";

let _: any = require("lodash");

const LAST_SELECTED_PROJECT_ID_KEY: string = "lastSelectedTeamId";
const LAST_SELECTED_PROJECT_MEMBER_ID_KEY: string = "lastSelectedTeamMemberId";
const cookieExpires: number = 1;

let getLastSelectedTeamIdFromCookie = function(): string {
  return Cookies.get(LAST_SELECTED_PROJECT_ID_KEY);
};

let getLastSelectedTeamMemberIdFromCookie = function(): number {
  let value: string = Cookies.get(LAST_SELECTED_PROJECT_MEMBER_ID_KEY);

  return value ? Number(value) : NaN;
};

// tslint:disable-next-line: interface-name
interface TeamState {
  loading: boolean;
  lastSelectedTeamId: string;
  lastSelectedMemberId: number;
  teams: Team[];
  myTeams: Team[];
  currentTeam: Team;
  currentTeamLoadingCount: number;
  currentTeamMembers: [];
}
//class BioMutations extends ListMutations<Team> {}

export const state: TeamState = {
  loading: false,
  lastSelectedTeamId: getLastSelectedTeamIdFromCookie() || null,
  lastSelectedMemberId: getLastSelectedTeamMemberIdFromCookie() || null,
  teams: new Array<Team>(),
  myTeams: new Array<Team>(),
  currentTeam: new Team(),
  currentTeamLoadingCount: 0,
  currentTeamMembers: []
};

const teamModule: Module<TeamState, any> = {
  namespaced: true,
  state,
  getters: {
    roleTitle: (state, getters) => role => {
      if (role === 1) {
        return getters.memberRoleTitle;
      } else {
        return "Fan";
      }
    },
    memberRoleTitle: state => {
      return "Member";
    },
    canAdd: (state, getters, rootState) => {
      let billingAccount = rootState.billing.billingAccount;
      let user = rootState.session.user;
      if (billingAccount && user) {
        let members = billingAccount.members.filter(m => m.memberId == user.id);
        if (members.length === 1) {
          let member = members[0];

          return member.grantedPermissions.includes("Bio.AddBio");
        }
      }

      return false;
    },
    canEditCurrentTeam: (state, getters) => {
      return state.currentTeam && state.currentTeam.grantedPermissions && state.currentTeam.grantedPermissions.includes("Bio.EditBio");
    },
    canInviteMemberInCurrentTeam: (state, getters, rootState) => {
      let billingAccount = rootState.billing.billingAccount;
      let user = rootState.session.user;

      if (state.currentTeam && state.currentTeam.grantedPermissions && billingAccount && user) {
        let members = billingAccount.members.filter(m => m.memberId == user.id);
        if (members.length === 1) {
          let member = members[0];

          let permissions = state.currentTeam.grantedPermissions.concat(member.grantedPermissions);
          return permissions.includes("Bio.AssignAuthorRole") || permissions.includes("Bio.AssignFan");
        }
      }

      return false;
    },
    getRoleDetails: (state, getters, rootState) => role => {
      if (role === 4) {
        return {
          value: 4,
          name: "fan",
          title: "Fan only",
          description: 'Fan only can "see-only" all team information. Not able to add, edit, and delete team information.'
        };
      } else if (role === 3) {
        return {
          value: 3,
          name: "member",
          title: "Contributor only",
          description: "Contributor only is accountable to xxx. Not able to add, edit, and delete prority information."
        };
      } else if (role === 6) {
        return {
          value: 6,
          name: "authorAndMember",
          title: "Author & Contributor",
          description: "Both author & contributor can add, edit, and delete team information."
        };
      } else {
        return null;
      }
    },
    currentTeamInviteRoles: (state, getters, rootState) => (memberId, team) => {
      let billingAccount = rootState.billing.billingAccount;
      if (!team) {
        team = state.currentTeam;
      }

      let results = [];
      if (team && team.grantedPermissions && billingAccount) {
        let members = billingAccount.members.filter(m => m.memberId == memberId);
        if (members.length === 1) {
          let member = members[0];

          results.push(
            Object.assign(
              {
                disabled: !(team.grantedPermissions.includes("Bio.AssignAuthorRole") && member.grantedPermissions.includes("Bio.BeAuthor"))
              },
              getters.getRoleDetails(6)
            )
          );

          results.push(
            Object.assign(
              {
                disabled: !(team.grantedPermissions.includes("Bio.AssignFan") && member.grantedPermissions.includes("Bio.BeFan"))
              },
              getters.getRoleDetails(4)
            )
          );
        }
      }

      return results;
    }
  },
  actions: {
    async getMyTeams(context: any, payload: any) {
      context.state.loading = true;
      let billingAccountId = window.abp && window.abp.custom.currentBillingAccountId ? window.abp.custom.currentBillingAccountId : 0;
      await Ajax.get(`/api/services/app/Team/GetMyTeams?billingAccountId=${billingAccountId}`).then(response => {
        let teams = response.data.result.myTeams;
        teams.forEach(team => {
          team.hashTagList = team.hashTags ? JSON.parse(team.hashTags) : [];
        });
        context.state.teams = teams;
        context.state.myTeams = teams;
      });
      context.state.loading = false;
    },
    create(context: ActionContext<TeamState, any>, payload: any) {
      let billingAccountId = window.abp && window.abp.custom.currentBillingAccountId ? window.abp.custom.currentBillingAccountId : 0;
      payload.data.billingAccountId = billingAccountId;
      Ajax.post("/api/services/app/Team/Create", payload.data).then(response => {
        context.dispatch("getMyTeams", {});
      });
    },
    update(context: ActionContext<TeamState, any>, payload: any) {
      Ajax.put("/api/services/app/Team/Update", payload.data).then(response => {
        context.dispatch("getMyTeams", {});
      });
    },
    copy(context: ActionContext<TeamState, any>, payload: any) {
      Ajax.post("/api/services/app/Team/Copy", payload.data).then(response => {
        context.dispatch("getMyTeams", {});
      });
    },
    delete(context: ActionContext<TeamState, any>, payload: any) {
      Ajax.delete("/api/services/app/Team/Delete?Id=" + payload.data.id).then(response => {
        context.dispatch("getMyTeams", {});
      });
    },
    async undelete(context: ActionContext<TeamState, any>, payload: any) {
      Ajax.post("/api/services/app/Team/Undelete?Id=" + payload.data.id).then(response => {
        context.dispatch("getMyTeams", {});
      });
    },
    async unarchive(context: ActionContext<TeamState, any>, payload: any) {
      Ajax.post("/api/services/app/Team/Unarchive?Id=" + payload.data.id).then(response => {
        context.dispatch("getMyTeams", {});
      });
    },
    async get(context: any, payload: any) {
      context.state.loading = true;
      await Ajax.get("/api/services/app/Team/Get?Id=" + payload.id).then(response => {
        let team = response.data.result as Team;

        context.state.currentTeam = team;
        context.state.currentTeamLoadingCount += 1;

        context.state.currentTeamMembers = team.members
          .filter(member => member.role !== 4)
          .map(member => {
            let roleName = member.role === 5 ? "Member" : "";
            return {
              id: member.memberId,
              name: `${member.memberName} - ${roleName}`,
              role: member.role,
              roleName: roleName
            };
          });
      });
      context.state.loading = false;

      return context.state.currentTeam;
    },
    async acceptInvitation(context: ActionContext<TeamState, any>, payload: any) {
      let result = null;

      await Ajax.post("/api/services/app/Team/AcceptInvitation", payload).then(response => {
        result = response;
      });

      return result;
    },
    async inviteMember(context: ActionContext<TeamState, any>, payload: any) {
      await Ajax.post("/api/services/app/Team/InviteMember", payload.data);
    },
    async updateMember(context: ActionContext<TeamState, any>, payload: any) {
      await Ajax.put("/api/services/app/Team/UpdateMember", payload.data);
    },
    async removeMember(context: ActionContext<TeamState, any>, payload: any) {
      let queryString = Object.keys(payload.data)
        .map(key => {
          return encodeURIComponent(key) + "=" + encodeURIComponent(payload.data[key]);
        })
        .join("&");
      await Ajax.delete(`/api/services/app/Team/RemoveMember?${queryString}`);
    },
    async updateContent(context: ActionContext<TeamState, any>, payload: any) {
      let result = null;
      await Ajax.put("/api/services/app/Team/UpdateContent", payload.data)
        .then(response => {
          context.state.currentTeam = response.data.result;
          result = response;
        })
        .catch(error => {
          console.log(error);
          return Promise.reject(error);
        });
      return result;
    },
    setLastSelectedTeamId(context: ActionContext<TeamState, any>, newValue: string) {
      Cookies.set(LAST_SELECTED_PROJECT_ID_KEY, newValue, { expires: cookieExpires });
      context.state.lastSelectedTeamId = newValue;
    },
    setLastSelectedMemberId(context: ActionContext<TeamState, any>, newValue: string) {
      Cookies.set(LAST_SELECTED_PROJECT_MEMBER_ID_KEY, newValue, { expires: cookieExpires });
      context.state.lastSelectedMemberId = Number(newValue);
    }
  }
};

export default teamModule;
